angular.module('ikeweb.error').value('cloudCodeErrors', {
    DUPLICATE: 'duplicate',
    USER_EXISTS: 'user_exists',
    FOLDER_NAME_EMPTY: 'folder_name_empty',
    INVALID_SIGNUP_TOKEN: 'invalid_signup_token'
});



//////////////////
// WEBPACK FOOTER
// ./src/client/error/cloud.code.errors.js
// module id = 158
// module chunks = 0